// Espace chauffeur — appels côté opérateur (admin Zeplan, JWT Firebase).

import axios from "axios";
import { apiRoot } from "../../index";
import { startLoading, stopLoading } from "../loader";

export async function publishOffersToDrivers(jwt, bookingIdList, audience) {
  startLoading();
  try {
    const res = await axios.post(
      apiRoot + "/api/v1/dispatch/driverapp/publish-offer",
      { bookingIdList, audience: audience || { all: true } },
      { headers: { authorization: jwt } }
    );
    return res.data;
  } finally {
    stopLoading();
  }
}

export async function withdrawOffersFromDrivers(jwt, bookingIdList) {
  startLoading();
  try {
    const res = await axios.post(
      apiRoot + "/api/v1/dispatch/driverapp/withdraw-offer",
      { bookingIdList },
      { headers: { authorization: jwt } }
    );
    return res.data;
  } finally {
    stopLoading();
  }
}

export async function getDriverAppLink(jwt, driverId, rotate = false) {
  startLoading();
  try {
    const res = await axios.post(
      apiRoot + "/api/v1/dispatch/driverapp/driver-app-link",
      { driverId, rotate },
      { headers: { authorization: jwt } }
    );
    return res.data.url;
  } finally {
    stopLoading();
  }
}
